import NotificationsTableController from './notifications-table.controller';

require('./notifications-table.scss');

const NotificationsTableComponent = {
    selector: 'sbNotificationsTable',
    template: require('./notifications-table.html'),
    controller: NotificationsTableController,
    bindings: {
        thingId: '<',
        fromDate: '<',
        toDate: '<',
    },
};

export default NotificationsTableComponent;



// WEBPACK FOOTER //
// ./src/app/detail/notifications-table/index.js